module.exports = __webpack_public_path__ + "static/media/react.91d2fe03.svg";